/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/require-default-props */

import { useCallback } from 'react';

import closeIco from 'assets/images/close-btn-black.svg';
import modalImg from 'assets/images/modals/NoShowsSetup.svg';
import { useTranslation } from 'providers/GILT.provider';

import Button from 'settings/page-elements/Button';

const NoShowModal = ({ btnClose, closeModal, popupTitle, onClickButton, btnName, disabled, children }) => {
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    const data = {
      ncob_deposit_settings: 'null',
      ncob_custom_amount: 0,
      no_show_protection: true,
    };

    onClickButton(data);
  }, [onClickButton]);

  return (
    <div>
      <div className="overlay" />
      <div className="confirmation-modal no-show animated zoomIn">
        <div className="modal-body">
          <span className={btnClose ? 'close hidden' : 'close'} onClick={closeModal}>
            <img src={closeIco} alt="Close modal" />
          </span>
          <h2 className="modal-title">{popupTitle}</h2>

          <div className="modal-content">
            <img src={modalImg} alt="" className="modal-img" />
            <div className="text-gray">
              {t('onlineBooking.generalSettings.businessStripeAccount.noShowModal.description1')}
            </div>
            <ul>
              <li>{t('onlineBooking.generalSettings.businessStripeAccount.noShowModal.description2Part1')}</li>
              <li>{t('onlineBooking.generalSettings.businessStripeAccount.noShowModal.description2Part2')}</li>
              <li>{t('onlineBooking.generalSettings.businessStripeAccount.noShowModal.description2Part3')}</li>
            </ul>
            {children}
          </div>
          <div className="modal-footer">
            <Button className="btn-violet" buttonName={btnName} onClickButton={handleClick} disabled={disabled} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoShowModal;
